module.exports = __webpack_public_path__ + "static/media/arrow_back.b95468f0.svg";